
import React from "react";
import { useMemorial } from "@/contexts/MemorialContext";
import { cn } from "@/lib/utils";

export const IntroductionSection: React.FC = () => {
  const { personalDetails } = useMemorial();

  if (!personalDetails.introduction) return null;

  // Determine if the text exceeds the character limit
  const isOverLimit = personalDetails.introduction.length > 500;
  const charactersRemaining = 500 - personalDetails.introduction.length;

  return (
    <div className="w-full max-w-3xl mx-auto px-4 mb-8 mt-1">
      <div className="bg-white rounded-lg shadow-lg p-6 text-center">
        <p 
          className={cn(
            "text-black italic font-body",  // Changed from text-secondary to text-black
            isOverLimit && "text-red-600"
          )}
        >
          {isOverLimit 
            ? personalDetails.introduction.substring(0, 500) + "..." 
            : personalDetails.introduction}
        </p>
      </div>
    </div>
  );
};
